import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, NgForm, UntypedFormControl, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ReCaptchaV3Service, OnExecuteData } from 'ng-recaptcha';
import { Subscription, Observable } from 'node_modules/rxjs';
import { LoginModel } from '@src/models/login.model';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '@src/app/services/userService.service';
import { TranslateService } from '@ngx-translate/core';
import Utils from '@src/app/helpers/Utils';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  matcher = new MyErrorStateMatcher();
  loading = false;
  userId = '';
  //bookType: string = 'KBK';
  private allExecutionsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;
  public readonly executionLog: OnExecuteData[] = [];
  public recentToken: string = '';
  public errors = [];

  loginForm = new UntypedFormGroup({
    login: new UntypedFormControl('', [Validators.required, Validators.minLength(2)]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(5)])
  });

  constructor(
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { 
    this.route.params.subscribe(params => {
      this.userId = params['userid'];
      // console.log('user is ' + this.userId);
    });

  }
  ngOnDestroy(): void {
    // if (this.allExecutionsSubscription) {
    //   this.allExecutionsSubscription.unsubscribe();
    // }
    // if (this.singleExecutionSubscription) {
    //   this.singleExecutionSubscription.unsubscribe();
    // }
  }

  ngOnInit() {
    sessionStorage.removeItem('token');

    // this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
    //   .subscribe((data) => this.executionLog.push(data));
  }
  handleRecaptchaExecute(action: any, token: any) {

  }
  setLang(langVal){
    //this.bookType = Utils.getBookType();
    Utils.setLang(this.translate, langVal);
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      return;
    }
    const loginModel: LoginModel = this.loginForm.value;

    this.userService.login(loginModel).subscribe((res) => {
      sessionStorage.setItem('token', res.token);
      this.router.navigate(['/report']);
    });
    return;


    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('onsubmit')
      .subscribe((token) => {
        this.recentToken = token;

        if (this.loginForm.invalid) {
          return;
        }
        const loginModel: LoginModel = this.loginForm.value;

        this.userService.login(loginModel).subscribe((res) => {
          sessionStorage.setItem('token', res.token);
          this.router.navigate(['/report']);
        });
      },
      (error) => {
        console.log(error);
        this.errors = [ 'Error trying to verify request (reCaptcha v3)' ];
        //console.log(this.errors);
      });
  }

}
